import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import CircleExclamationIcon from '@components/ui/svgIcons/CircleExclamationIcon'

const WarningBadgeWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.primary[50]};
`

const StyledSpan = styled.span`
  display: inline-block;
  font-weight: 700;
  margin-right: 2px;
  font-size: 14px;
`

interface WarningBadgeProps {
  isDuplicated?: boolean
  isNav?: boolean
}

function WarningBadge({ isDuplicated = false, isNav = false }: WarningBadgeProps) {
  return (
    <WarningBadgeWrapper className="missing-warning">
      <StyledSpan>
        {isDuplicated ? (
          isNav ? (
            <FormattedMessage id="badge.navDuplicated" defaultMessage="NAV duplikáció" />
          ) : (
            <FormattedMessage id="badge.duplicated" defaultMessage="Duplikáció" />
          )
        ) : (
          <FormattedMessage id="badge.deficient.data" defaultMessage="Adathiányos" />
        )}
      </StyledSpan>
      {isDuplicated && <CircleExclamationIcon size={14} />}
    </WarningBadgeWrapper>
  )
}

export function DeficientBadge() {
  return <WarningBadge />
}

export function DuplicatedBadge({ isNav }: Pick<WarningBadgeProps, 'isNav'>) {
  return <WarningBadge isDuplicated isNav={isNav} />
}
